document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-klaviyo-trigger]');
    if (!trigger) return;

    e.preventDefault();

    if (window._klOnsite && typeof window._klOnsite.openForm === 'function') {
      window._klOnsite.openForm('SVBfGY');
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'SVBfGY']);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-ds-klaviyo-trigger');
    if (!trigger) return;
    var formId = trigger.getAttribute('data-klaviyo-form');
    if (!formId) return;
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
});

/* ========================================
DS HEADER SEARCH INTERACTION
Controls expanding search behavior in header:
- Click icon → expands input + focuses cursor
- Click outside → closes search
- Press ESC → closes search
- Submit → closes search
======================================== */

document.addEventListener("DOMContentLoaded", function () {
  const search = document.querySelector(".ds-header-search");
  const toggle = document.querySelector(".ds-search-toggle");
  const input = document.querySelector(".ds-search-input");

  // Exit early if elements are missing
  if (!search || !toggle || !input) return;

  // Scope form to this search component (prevents conflicts)
  const form = search.querySelector(".ds-search-form");

  // Toggle search open/close on icon click
  toggle.addEventListener("click", function (e) {
    e.stopPropagation();

    search.classList.toggle("is-active");

    if (search.classList.contains("is-active")) {
      toggle.setAttribute("aria-expanded", "true");

      // Slight delay ensures smooth animation before focusing
      setTimeout(() => input.focus(), 200);
    } else {
      toggle.setAttribute("aria-expanded", "false");
    }
  });

  // Close search when clicking outside of it
  document.addEventListener("click", function (e) {
    if (!search.contains(e.target)) {
      search.classList.remove("is-active");
      toggle.setAttribute("aria-expanded", "false");
    }
  });

  // Close search when pressing ESC key
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      search.classList.remove("is-active");
      toggle.setAttribute("aria-expanded", "false");
    }
  });

  // Close search on form submit
  if (form) {
    form.addEventListener("submit", function () {
      search.classList.remove("is-active");
      toggle.setAttribute("aria-expanded", "false");
    });
  }
});